angular.module(module.exports = 'ttb.issue.workLogDetails.workLogEditor.editDay.component', [])
    .component('editDay', {
        template: `
            <ng-form class="edit-day">
                <fieldset ng-disabled="!$ctrl.day || $ctrl.readOnly">
                    <div class="row">
                        <div class="col-xs-2">
                            <p class="form-control-static">
                                <span class="pull-left day-of-week" ng-class="{'text-primary': $ctrl.day && $ctrl.day.value.isWorking,
                                                    'text-success': $ctrl.day && !$ctrl.day.value.isWorking,
                                                    'text-muted': !$ctrl.day    }">{{$ctrl.dayOfWeek.weekday}}.</span> 
                                <span class="pull-left day-date">{{$ctrl.day.dayDate}}<span class="text-muted dash" ng-hide="$ctrl.day">&mdash;</span></span>
                            </p>
                        </div>
                        <div class="col-xs-3 day-duration-col show-lock-icon">
                        <span class=day-lock-panel>
                            <i title="{{'WorkLog_LockUnlockDayTitle' | translate}}" class="fa" ng-class="{'fa-lock': $ctrl.day.value.isOverriden, 'fa-unlock': !$ctrl.day.value.isOverriden}" ng-click="$ctrl.lockChange()" ng-show="$ctrl.day" />
                        </span>
                            <duration-input 
                                ng-show="$ctrl.day"
                                read-only="!$ctrl.day || $ctrl.readOnly || $ctrl.day.value.isOverriden"
                                formatter="$ctrl.formatter" name="duration" placeholder="$ctrl.durationPlaceholder"
                                throttle-delay="1000" ng-model="$ctrl.day.value.duration"
                                duration on-change="$ctrl.change()" max-minutes="1440"></duration-input>

                                <child-duration ng-show="$ctrl.day" formatter="$ctrl.formatter" activity-sub-items="$ctrl.day.value.activitySubItems" child-duration="$ctrl.day.value.childDuration"></child-duration>
                            <p class="form-control-static text-muted dash" ng-hide="$ctrl.day">&mdash;</p>
                        </div>
                        <div class="col-xs-6">
                            <input ng-show="$ctrl.day" name="comment" type="text"
                                class="form-control" ng-model="$ctrl.day.value.comment" ng-placeholder="$ctrl.commentPlaceholder()" maxlength="500"></input>
                            <p class="form-control-static text-muted dash" ng-hide="$ctrl.day">&mdash;</p>
                        </div>
                    </div>
                </fieldset>
            </ng-form>
        `,
        bindings: {
            day: '<',
            formatter: '<',
            dayOfWeek: '<',
            readOnly: '<',
            onChange: '&',
            onLockChange: '&',
        },
        controller: EditDay
    });

function EditDay($translate) {
    this.$onInit = () => {
        this.commentPlaceholder = () => {
            if (this.day) {
                return this.day.value.isWorking ? $translate.instant('WorkLog_AddComment') : $translate.instant('WorkLog_DayOff');
            }
            return '';
        }
    };
    this.lockChange =() =>
    {
        this.day.value.isOverriden = !this.day.value.isOverriden
        this.onLockChange();
    }
    this.change = () => {
        this.onChange();
    };
}
EditDay.$inject = ["$translate"];


// WEBPACK FOOTER //
// ./components/work-log-editor/edit-form/edit-day.component.js